import React, { useState } from 'react'

import { MANAGEMENT_QUERY_KEY_SEARCH_UNIT_FIRMWARES, useManagementSearchUnitFirmwares } from '@apps-common/apis/management/unit-firmware'
import { UnitFirmwareModal } from '@apps-common/apps/portal/pages/management/components/unit-firmware'
import { ButtonRoundSm } from '@apps-common/components/elements'
import { Table } from '@apps-common/components/elements/table'
import { LayoutContainer, LayoutPadding } from '@apps-common/components/layout'
import { ModalButton } from '@apps-common/components/modals'
import { commonIcons } from '@apps-common/config/icons'
import { queryClient } from '@apps-common/lib'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'

interface IProps {
  searchVal: string
}

export const UnitFirmwareTableView: React.FC<IProps> = ({ searchVal }) => {
  const [skip, setSkip] = useState<number>(0)
  const [take, setTake] = useState<number>(10)
  const { isLoading, isError, data } = useManagementSearchUnitFirmwares({
    search: searchVal
  })

  const keys = [
    {
      title: 'Firmware Version',
      key: 'unitFirmwareVersion',
      thClasses: '',
      tdClasses: ''
    },
    {
      title: 'Default',
      key: 'defaultItem',
      thClasses: '',
      tdClasses: '',
      Component: (props: any) => (
        <span>{props.defaultItem ? <commonIcons.check className='text-[1.6rem]' /> : <commonIcons.close className='text-[1.4em]' />}</span>
      )
    },
    {
      title: 'Actions',
      key: 'actions',
      static: true,
      thClasses: 'text-right',
      tdClasses: '',
      Component: (props: any) => (
        <div className='flex items-center justify-end gap-[5px]'>
          <ModalButton
            component={UnitFirmwareModal}
            componentProps={{
              unitFirmwareId: props.unitFirmwareId
            }}
            confirmCallback={() => {
              queryClient.invalidateQueries({ queryKey: MANAGEMENT_QUERY_KEY_SEARCH_UNIT_FIRMWARES(searchVal) })
            }}
            enterAnimation={modalSlideUpEnterAnimation}
            leaveAnimation={modalSlideUpLeaveAnimation}
          >
            <ButtonRoundSm type='div' className='action-brand-solid'>
              <commonIcons.arrowAngled />
            </ButtonRoundSm>
          </ModalButton>
        </div>
      )
    }
  ]

  const loading = isLoading || isError || !data

  return (
    <LayoutContainer>
      <LayoutPadding topPadding='pt-[65px] sm:pt-[25px]'>
        <Table
          loading={loading}
          loadingSkeletonHeight='leading-[30px]'
          placeholderSkeletonHeight='leading-[30px]'
          pagination={{
            loading,
            count: data?.length || 0,
            skip,
            take,
            onSkipChanged: (value: number) => setSkip(value),
            onTakeChanged: (value: number) => setTake(value)
          }}
          keys={keys}
          data={data?.map((c) => ({ ...c, companies: data })) || []}
          sliceData
          topLeftComponent={
            <>
              {!loading && data && (
                <div className='jost-light'>
                  <span className='jost-medium'>{data?.length}</span> company results
                </div>
              )}
              {(loading || !data) && <div className='h-[22px] w-[100px] bg-skeleton rounded-lg' />}
            </>
          }
          onSkipChanged={(value: number) => setSkip(value)}
          onTakeChanged={(value: number) => setTake(value)}
        />
      </LayoutPadding>
    </LayoutContainer>
  )
}
